<template>
    <vue-excel-xlsx
    :data="tableData"
    :columns="tableColumns"
    :filename="filename"
    :sheetname="filesheet"
    >
        <el-button :size="size" :type="color" :icon="icon" :disabled="disabled"> {{ text }}</el-button>
    </vue-excel-xlsx>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: 'Extract'
        },
        tableColumns: {
            type: Array
        },
        tableData:  {
            type: Array,
        },
        filename: {
            type: String,
            default: 'exported-xlsx'
        },
        filesheet: {
            type: String,
            default: 'Sheet1'
        },
        size: {
            type: String,
            default: 'small'
        },
        color: {
            type: String,
            default: 'primary'
        },
        icon: {
            type: String,
            default: 'mdi mdi-download'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>